/*
 * @Author: FengXiao
 * @Date: 2020-07-02 15:19:31
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-01 00:47:43
 */
// import requestApi from '@/service';

export default {
  initScrollTop() {
    window.scrollTo(0, 0);
  },
  refreshCurrentPage() {
    this.$router.go(0);
  },
  // 截流
  _riverClosure(name, time) {
    const key = `${key}RiverClosure`;
    if (this[key]) return false;
    this[key] = setTimeout(() => {
      this[key] = null;
    }, time);
    return true;
  },
  // 防抖
  _debounce(cb, key, time) {
    if (this[`Debounce-${key}`]) {
      clearTimeout(this[`Debounce-${key}`]);
    }
    this[`Debounce-${key}`] = setTimeout(() => {
      this[`Debounce-${key}`] = null;
      cb && cb();
    }, time);
  },
  checkLogin(guideType = 'mini') {
    // 隐私改版：全站匿名访问，不再存在登录态，仅统一弹出引导（调用方按返回 false 中断后续操作）
    this.gotoLogin(guideType);
    return false;
  },
  gotoLogin(guideType = 'mini') {
    // 隐私改版：不再跳转登录页，统一引导（默认小程序，需要App的操作由调用方指定 'app'）
    this.$store.commit('showGuide', guideType);
  },
};
